import { IBookInterval } from "@/domain/entities/lineInfo";
import { IResultData } from "@/domain/entities/shared/result";
import TYPES from "@/ioc/identifiers";
import { ILineInfoRepository } from "@/repositories/lineInfo/lineInfoRepository.types";
import useSetResultCodeIfNeeded from "@/use/useSetResultCodeIfNeeded";
import { inject, injectable } from "inversify";

export interface GetBookIntervalsUseCase {
  execute(turnId?: string): Promise<IResultData<IBookInterval[]>>;
}

@injectable()
export class GetBookIntervals implements GetBookIntervalsUseCase {
  private lineRepository: ILineInfoRepository;

  constructor(
    @inject(TYPES.ILineInfoRepository) lineRepository: ILineInfoRepository
  ) {
    this.lineRepository = lineRepository;
  }

  async execute(turnId?: string): Promise<IResultData<IBookInterval[]>> {
    const bookIntervalsResult: IResultData<IBookInterval[]> = {
      isSuccess: false,
    };

    await this.lineRepository
      .getBookIntervals(turnId)
      .then((result) => {
        result
          .map((bookIntervals) => {
            bookIntervalsResult.isSuccess = true;
            bookIntervalsResult.data = bookIntervals;
          })
          .mapErr((error) => {
            useSetResultCodeIfNeeded(bookIntervalsResult, error);
            bookIntervalsResult.errorMessage = error.message;
          });
      })
      .catch((error) => {
        bookIntervalsResult.errorMessage = error.message;
      });

    return bookIntervalsResult;
  }
}
